/**
 * 常用功能配置 API
 * 传参/响应字段：title、iconUrl、pageUrl、carryParam、moduleType、sort
 * 接口前缀：/{sysPrefix}/sys/configuration/gl/v1.0.0/
 */
import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

const BASE = `/${systemConfig.sysPrefix}/sys/configuration/gl/v1.0.0`

/** 分页列表 */
export function commonFunctionPage(data) {
  return request({
    url: `${BASE}/page`,
    method: 'post',
    data
  })
}

/** 详情 */
export function commonFunctionDetail(data) {
  return request({
    url: `${BASE}/detail`,
    method: 'post',
    data
  })
}

/** 新增 */
export function commonFunctionAdd(data) {
  return request({
    url: `${BASE}/add`,
    method: 'post',
    data
  })
}

/** 修改 */
export function commonFunctionUpdate(data) {
  return request({
    url: `${BASE}/update`,
    method: 'post',
    data
  })
}

/** 删除 */
export function commonFunctionDelete(data) {
  return request({
    url: `${BASE}/delete`,
    method: 'post',
    data
  })
}
